<template>
<div id="cartaporte">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="mdi-cash" title="Nuevo Pago" class="elevation-1 ">

                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                                <div style="width:95%; position:absolute; top:0px;">
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="6" md="6" lg="6">
                                            <v-alert color="green" outlined dense type="info"><span style="font-size:10px;">Si no se específica la Serie y Folio el sistema asignara en automático el de la configuración.</span></v-alert>

                                        </v-col>

                                    </v-row>
                                    <v-row style="width:100%; position:absolute; top:45px; left:10px;">
                                        <v-col sm="6" md="6" lg="6">
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-if="series.length==0" v-model="model.serie" label="Serie"></v-text-field>
                                            <v-autocomplete v-if="series.length>0" v-model="model.serie" label="Serie" :items="series" clearable item-text="text" item-value="id">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-model="model.folio" label="Folio"></v-text-field>
                                        </v-col>
                                    </v-row>

                                </div>
                                <p />
                                <v-row>
                                    <v-col sm="4" md="4" lg="4">
                                        <h5><b>Emisor</b> </h5><span class="title">{{model.emisor.rfc}} - {{model.emisor.razon_social}}</span>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="model.FechaFactura" label="Fecha Factura" readonly v-bind="attrs" v-on="on" @click:clear="model.FechaFactura = null"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.FechaFactura" no-title locale="MX" @change="menu2 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>

                                <p />
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.receptor" label="Receptor" return-object :items="receptores" :hide-no-data="true" item-text="razon_social" item-value="uuid" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.rfc}} - {{ item.razon_social}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.rfc}} - {{ item.razon_social}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-text-field v-model="model.UUID" label="Folio Fiscal UUID" :rules="[rules.required]"></v-text-field>
                                    </v-col>

                                </v-row>
                                <p />
                                <v-row>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :value="model.FechaPago" label="Fecha Pago" readonly v-bind="attrs" v-on="on" @click:clear="model.FechaPago = null"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.FechaPago" no-title locale="MX" @change="menu1 = false"></v-date-picker>
                                        </v-menu>

                                    </v-col>
                                    <v-col sm="6" md="6" lg="6">
                                        <v-autocomplete v-model="model.FormaPago" label="Forma Pago" :items="FormasPago" :hide-no-data="true" item-text="nombre" item-value="clave" :rules="[rules.required]">
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <span class="pr-2">
                                                    {{item.clave}} - {{ item.nombre}}
                                                </span>
                                            </template>
                                            <template v-slot:item="{ index, item }">
                                                {{item.clave}} - {{ item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <p />

                                <v-row>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.Pago.No" label="Número de Parcialidad" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.Pago.Saldo" @change="actualizaSaldo" label="Importe Saldo Anterior" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.Pago.Pagado" @change="actualizaSaldo" label="Importe Pagado" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col sm="3" md="3" lg="3">
                                        <v-text-field v-model="model.Pago.Insoluto" label="Importe Saldo Insoluto" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <p />
                                <h5>IMPUESTOS</h5>
                                <v-row>
                                    <v-col sm="2" md="2" lg="2">
                                        <h5 style="color:green">IVA TRASLADADO </h5>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="iva_traslado" label="Tasa"></v-text-field>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="importe_iva_traslado" label="Importe"></v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col sm="2" md="2" lg="2">
                                        <h5 style="color:green">IVA RETENIDO </h5>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="iva_retenido" label="Tasa"></v-text-field>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="importe_iva_retenido" label="Importe"></v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col sm="2" md="2" lg="2">
                                        <h5 style="color:green">ISR RETENIDO </h5>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="isr_retenido" label="Tasa"></v-text-field>
                                    </v-col>
                                    <v-col sm="2" md="2" lg="2">
                                        <v-text-field v-model="importe_isr_retenido" label="Importe"></v-text-field>
                                    </v-col>

                                </v-row>
                                <p />

                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="success" large @click.native="timbrar()">
                            <v-icon>mdi-qrcode</v-icon> Generar CFDI de Pago
                        </v-btn>
                    </v-card-actions>
                </base-material-card>
                <pre>
             <!--        {{this.$local_storage.get('TOTAL')}}<br/>
               {{impuestos}}<br/>
                {{timbre}} -->
               
                </pre>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
    name: "DashboardDataTables",

    data: () => ({
        series: [],
        url: 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/',
        nota: "",
        menu1: false,
        menu2: false,
        computedDateFormatted: "",
        esObjeto: "01",
        model: {
            concarta: true,
            serie: "",
            folio: "",
            UsoCFDI: "G03",
            Moneda: "MXN",
            TipoDeComprobante: "T",
            LugarExpedicion: "06300",
            FormaPago: "03",
            UUID: "",
            FechaPago: "",
            FechaFactura: "",
            TipoCambio: "1",
            MetodoPago: "PUE",
            emisor: "",
            Pago: {
                No: "1",
                Saldo: "",
                Pagado: "",
                Insoluto: ""
            },
            receptor: {
                "registro_fiscal": ""
            },
            uuid_empresa: "",
            uuid_licencia: "",
            uuid: "",
            estatus: "",
            fecha: "",
            tipo: "",
            observaciones: "",
        },
        iva_traslado: 0,
        iva_retenido: 0,
        isr_retenido: 0,
        importe_iva_traslado: 0,
        importe_iva_retenido: 0,
        importe_isr_retenido: 0,
        base_gravable: 0,
        total_factura: "0.00",
        subtotal_factura: "0.00",
        imp_traslado_factura: "0.00",
        imp_retenido_factura: "0.00",
        impuestos: [],
        isr_retenido: 0,
        descuento_factura: "0.00",
        iva_traslado: 0,
        iva_retenido: 0,
        descuento: 0,
        subtotal_producto: 0,
        total_producto: 0,
        producto: "",
        cantidad: 1,
        producto2: "",
        cantidad2: 1,
        nota: "",
        precio: 0,
        UsosCFDI: [],
        FormasPago: [],
        MetodosPago: [],
        Monedas: [{
                clave: "MXN",
                nombre: "PESO MEXICANO"
            },
            {
                clave: "USD",
                nombre: "DOLAR ESTADOUNIDENCE"
            },
            {
                clave: "EUR",
                nombre: "EURO"
            }
        ],
        TiposDeComprobante: [{
                clave: "T",
                nombre: "TRASLADO"
            },
            {
                clave: "I",
                nombre: "INGRESO"
            },
        ],
        timbre: "",
        tabla: "carta_porte",
        uuid_editando: "",
        con_mercancias: false,
        origenes: [],
        destinos: [],
        receptores: [],
        remolques: [],
        figuras: [],
        transportes: [],
        productos: [],
        mercancias: [],
        modal: false,
        usuario: "",
        clientes: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "Pago",
                disabled: true,
                href: "",
            },
        ],
        rules: {},
        columns_productos: ["producto.nombre", "cantidad", "precio", "subtotal", "descuento", "iva_traslado", "iva_retenido", "total", "actions"],
        options_productos: {
            filterable: false,
            headings: {
                'producto.nombre': "Producto",
                catidad: "Cantidad",
                'precio': "Precio",
                "subtotal": "Subtotal",
                "descuento": "Descuento",
                "iva_traslado": "Trasladado",
                "iva_retenido": "Retenido",
                "total": "Total",
                actions: "Operaciones"
            }
        },
        columns_mercancias: ["producto.nombre", "cantidad", "nota", "actions"],
        options_mercancias: {
            filterable: false,
            headings: {
                'producto.nombre': "Mercancia",
                catidad: "Cantidad",
                nota: "Nota",
                actions: "Operaciones"
            }
        },
        columns_mercancias_sincarta: ["producto.nombre", "cantidad", "actions"],
        options_mercancias_sincarta: {
            filterable: false,
            headings: {
                'producto.nombre': "Producto",
                catidad: "Cantidad",
                actions: "Operaciones"
            }
        },
        items: [],
    }),
    computed: {
        nombre() {
            let nombre_usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
            return nombre_usuario;
        }
    },
    methods: {
        validaRemolque: function () {
            try {
                if (this.model.remolque1 != undefined && this.model.remolque1 != null && this.model.remolque1 != "")
                    if (this.model.remolque1 == this.model.remolque2)
                        return "Remolque se encuentra duplicado";

                return true;
            } catch (error) {
                return true;
            }
        },
        actualizaSaldo: function () {

            if (parseFloat(this.model.Pago.Saldo) > 0 && parseFloat(this.model.Pago.Pagado) > 0) {
                let insoluto = parseFloat(this.model.Pago.Saldo) - parseFloat(this.model.Pago.Pagado);
                insoluto = insoluto.toFixed(2);
                this.model.Pago.Insoluto = insoluto.toString();
                
                var subtt = 0;
                var ax = 0;
                var bx = 0;
                var cx = 0;
                var xx = 0;


                if (parseFloat(this.isr_retenido) > 0){
                    this.importe_isr_retenido = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1+ parseFloat(this.isr_retenido))) ).toFixed(2);
                    cx = parseFloat(this.isr_retenido);
                }   
                else
                    this.importe_isr_retenido = "0.00";
                if (parseFloat(this.iva_retenido) > 0){
                    this.importe_iva_retenido = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1 + parseFloat(this.iva_retenido))) ).toFixed(2);
                    bx = parseFloat(this.iva_retenido);
                }
                else
                    this.importe_iva_retenido = "0.00";
                if (parseFloat(this.iva_traslado) > 0){
                    this.importe_iva_traslado = (parseFloat(this.model.Pago.Pagado)- (parseFloat(this.model.Pago.Pagado) / (1+ parseFloat(this.iva_traslado))) ).toFixed(2);
                    ax = parseFloat(this.iva_traslado);
                }
                else
                    this.importe_iva_traslado = "0.00";


                xx = ax - bx + cx;

                if (xx != 0) {
                    subtt = parseFloat(this.model.Pago.Pagado) / (xx + 1);

                    if (cx > 0) {
                        this.importe_isr_retenido = (subtt * parseFloat(this.isr_retenido)).toFixed(2);
                    }

                    if (bx > 0) {
                        this.importe_iva_retenido = (subtt * parseFloat(this.iva_retenido)).toFixed(2);
                    }

                    if (ax  > 0) {
                        this.importe_iva_traslado = (subtt * parseFloat(this.iva_traslado)).toFixed(2);
                    }
                }

                this.base_gravable = parseFloat(this.model.Pago.Pagado) + parseFloat(this.importe_isr_retenido) + parseFloat(this.importe_iva_retenido) - parseFloat(this.importe_iva_traslado ); 
            } else
                this.model.Pago.Insoluto = "";
        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },

        cargarCatalogosSAT: function () {
            var self = this;

            this.$axios.post(this.URL_SAT + "list_usos_cfdi/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.UsosCFDI = res.data;
                    }
                });

            this.$axios.post(this.URL_SAT + "list_formas_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {

                        self.FormasPago = res.data.sort(function (a, b) {
                            if (parseInt(a.clave) > parseInt(b.clave))
                                return 1;
                            if (parseInt(a.clave) < parseInt(b.clave))
                                return -1;
                            return 0;
                        });
                    }
                });

            this.$axios.post(this.URL_SAT + "list_metodos_pago/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        self.MetodosPago = res.data;
                    }
                });

        },
        cargarOrigenes: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
            axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.origenes = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarDestinos: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "uuid_empresa": this.model.uuid_empresa,
            };
            axios.post(self.URL + 'list_ubicaciones/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.destinos = res.data;
                    }
                });

            this.$root.$dialogLoader.hide();
        },
        cargarEmisor: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
                filtros: {
                    "uuid": this.model.uuid_empresa
                }
            };
            axios.post(self.URL_ADM + 'list_empresas/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.model.emisor = res.data[0];

                        if (res.data[0].catalogo_series != undefined && res.data[0].catalogo_series.length > 0) {
                            res.data[0].catalogo_series.forEach(function (x) {
                                self.series.push({
                                    "id": x.serie,
                                    "text": x.serie
                                });
                            });
                        }
                        self.model.LugarExpedicion = self.model.emisor.domicilio.codigo_postal;
                        self.cargarOrigenes();
                        self.cargarDestinos();

                    }
                    self.$root.$dialogLoader.hide();
                });
        },
        cargarReceptores: function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            let rfc = this.$local_storage.get('RFC_RECEPTOR');
            if (rfc != null)
                var data = {
                    "uuid_empresa": this.model.uuid_empresa,
                    "rfc": this.$local_storage.get('RFC_RECEPTOR')
                };
            else
                var data = {
                    "uuid_empresa": this.model.uuid_empresa
                };

            axios.post(self.URL + 'list_clientes/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        self.receptores = res.data;

                        var filter = self.receptores;
                        self.model.receptor = filter[0];
                        if (filter.length == 0) {
                            let r = JSON.parse(self.$local_storage.get('RECEPTOR'));

                            var record = {};
                            record.rfc = r.Rfc;
                            record.razon_social = r.Nombre;
                            record.regimen_fiscal_receptor = r.RegimenFiscalReceptor;
                            record.domicilio = {};
                            if (r.Domicilio != undefined) {
                                record.domicilio.calle = r.Domicilio.Calle;
                                record.domicilio.codigo_postal = r.Domicilio.CodigoPostal;
                                record.domicilio.colonia = r.Domicilio.Colonia;
                                record.domicilio.estado = r.Domicilio.Estado;
                                record.domicilio.localidad = r.Domicilio.Localidad;
                                record.domicilio.municipio = r.Domicilio.Municipio;
                                record.domicilio.numero_ext = r.Domicilio.NumeroExterior;
                                record.domicilio.pais = r.Domicilio.Pais;
                            } else {
                                record.domicilio.calle = "";
                                record.domicilio.codigo_postal = "";
                                record.domicilio.colonia = "";
                                record.domicilio.estado = "";
                                record.domicilio.localidad = "";
                                record.domicilio.municipio = "";
                                record.domicilio.numero_ext = "";
                                record.domicilio.pais = "";
                            }

                            if (r.email != undefined)
                                record.email = r.Email;

                            self.receptores.push(record);
                            self.model.receptor = record;

                        }

                    }
                    self.$root.$dialogLoader.hide();
                });
        },

        validar: function () {
            var self = this;
            if (this.$refs.form.validate()) {
                if (self.model.concarta == true) {
                    if (self.model.hora_salida == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Salida",
                            footer: "",
                        });
                        return false;
                    }
                    if (self.model.hora_llegada == "") {
                        self.$swal({
                            type: "error",
                            title: "Datos Incompletos",
                            text: "Debe especificar fecha y hora de Llegada",
                            footer: "",
                        });
                        return false;
                    }
                    const hs = new Date(self.model.hora_salida);
                    const he = new Date(self.model.hora_llegada);

                    if (hs > he) {
                        self.$swal({
                            type: "error",
                            title: "Datos Incorrectos",
                            text: "La Fecha y Hora de Salida no puede ser mayor a la de entrada",
                            footer: "",
                        });
                        return false;
                    }
                }

                return true;

            } else {
                self.$swal({
                    type: "error",
                    title: "Datos Incompletos",
                    text: "Verifique la informacón y vuelva a intentarlo",
                    footer: "",
                });
                return false;
            }

        },
        enviarTimbrar: function () {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            self.$root.$dialogLoader.show("Espere un momento por favor..");

            var data = {
                "rfc": self.model.emisor.rfc,
                "json": self.timbre,
                "usuario": self.nombre
            };
            axios.post(self.url + 'carta_porte/guardar_mongo/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se envio correctamente. ",
                            footer: "No. de Solicitud: " + res.data.id_solicitud,
                        });
                        self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(res.data.id_solicitud));
                        self.$router.replace("/cartaporte");
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.$local_storage.set(self.$crypto.SHA256("id_solicitud"), self.$crypto.encrypted(''));
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    self.$root.$dialogLoader.hide();
                });

        },

        guardar: function (item) {
            var self = this;

            if (this.validar()) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                let uuid = self.$uuid.v4();
                let metodo = "save_pre_carta_porte/";

                if (self.model.TipoDeComprobante == 'T' && self.model.concarta == true) {
                    self.model.lista_mercancias = [];
                    self.model.Moneda = "MXN";
                    self.model.FormaPago = "01";
                    self.model.TipoCambio = "1";
                    self.model.MetodoPago = "PUE";
                    self.model.receptor = self.model.emisor;
                }
                let data = self.model;

                data.uuid = uuid;
                data.estatus = 0;
                data.fecha = moment().format("YYYY-MM-DD HH:mm:ss").replace(' ', 'T');
                data.tipo = "Web";
                let param = {
                    "datos": data
                }

                this.$axios.post(this.$hostname + "carta_porte/" + metodo, param)
                    .then(res => {

                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se guardó correctamente.",
                            footer: "",
                        });
                        self.$root.$dialogLoader.hide();
                        return true;

                    });
            } else {
                return false;
            }
        },
        cancelar: function () {

            this.$router.replace("/pre_carta_porte");
        },

        timbrar: function () {
            if (this.validar()) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");

                var self = this;

                let lugar = self.model.LugarExpedicion;
                if (self.model.receptor.rfc != 'XAXX010101000') {
                    lugar = self.model.receptor.domicilio.codigo_postal;
                }

                self.timbre = {
                    "Version": "4.0",
                    "SubTotal": "0",
                    "Total": "0",
                    "Serie": "",
                    "Folio": "",
                    "Exportacion": "01",
                    "NoCertificado": "",
                    "Fecha": this.model.FechaFactura + 'T00:00:00',
                    "Moneda": "XXX",
                    "TipoDeComprobante": "P",
                    "LugarExpedicion": self.model.LugarExpedicion,
                    "Emisor": {
                        "Nombre": self.model.emisor.razon_social,
                        "RegimenFiscal": self.model.emisor.regimen,
                        "Rfc": self.model.emisor.rfc,
                        "Domicilio": {
                            "Calle": self.model.emisor.domicilio.calle,
                            "CodigoPostal": self.model.emisor.domicilio.codigo_postal,
                            "Colonia": self.model.emisor.domicilio.colonia,
                            "Estado": self.model.emisor.domicilio.estado,
                            "Localidad": self.model.emisor.domicilio.localidad,
                            "Municipio": self.model.emisor.domicilio.municipio,
                            "NumeroExterior": self.model.emisor.domicilio.numero_ext,
                            "Pais": self.model.emisor.domicilio.pais,
                            "Referencia": ""
                        },
                    },
                    "Receptor": {
                        "Rfc": self.model.receptor.rfc,
                        "Nombre": self.model.receptor.razon_social,
                        "UsoCFDI": "CP01",
                        "RegimenFiscalReceptor": self.model.receptor.regimen_fiscal_receptor,
                        "DomicilioFiscalReceptor": lugar,
                        "Domicilio": {
                            "Calle": self.model.receptor.domicilio.calle,
                            "CodigoPostal": self.model.receptor.domicilio.codigo_postal,
                            "Colonia": self.model.receptor.domicilio.colonia,
                            "Estado": self.model.receptor.domicilio.estado,
                            "Localidad": self.model.receptor.domicilio.localidad,
                            "Municipio": self.model.receptor.domicilio.municipio,
                            "NumeroExterior": self.model.receptor.domicilio.numero_ext,
                            "Pais": self.model.receptor.domicilio.pais,
                            "Referencia": ""
                        },
                        "Email": self.model.receptor.email
                    },
                    "Conceptos": [{
                        "Cantidad": "1",
                        "ClaveProdServ": "84111506",
                        "ClaveUnidad": "ACT",
                        "Descripcion": "Pago",
                        "Importe": "0",
                        "ValorUnitario": "0",
                        "ObjetoImp": "01"
                    }],

                    "Complemento": {
                        "Pagos": {
                            "Version": "2.0",
                            "Totales": {
                                "MontoTotalPagos": self.model.Pago.Pagado.toString()
                            },
                            "Pago": [{
                                "FechaPago": self.model.FechaPago + 'T00:00:00',
                                "FormaDePagoP": self.model.FormaPago,
                                "MonedaP": "MXN",
                                "Monto": self.model.Pago.Pagado,
                                "TipoCambioP": "1",
                                "DoctoRelacionado": [{
                                    "IdDocumento": self.model.UUID,
                                    "MonedaDR": "MXN",
                                    "EquivalenciaDR": "1",
                                    "NumParcialidad": self.model.Pago.No,
                                    "ImpSaldoAnt": self.model.Pago.Saldo,
                                    "ImpPagado": self.model.Pago.Pagado,
                                    "ImpSaldoInsoluto": self.model.Pago.Insoluto,
                                    "ObjetoImpDR": self.esObjeto
                                }]
                            }]
                        }
                    },

                };

                if (self.esObjeto == "02") {
                    self.timbre.Complemento.Pagos.Pago[0].DoctoRelacionado[0].ImpuestosDR = {};
                    if (parseFloat(self.importe_iva_traslado) > 0) {
                        self.timbre.Complemento.Pagos.Pago[0].DoctoRelacionado[0].ImpuestosDR.TrasladosDR = [];
                        self.timbre.Complemento.Pagos.Pago[0].DoctoRelacionado[0].ImpuestosDR.TrasladosDR[0] = {
                            "BaseDR": self.base_gravable,
                            "ImpuestoDR": "002",
                            "TipoFactorDR": "Tasa",
                            "ImporteDR": self.importe_iva_traslado,
                            "TasaOCuotaDR": self.iva_traslado
                        };
                    }
                    if (parseFloat(self.importe_iva_retenido) > 0) {
                        self.timbre.Complemento.Pagos.Pago[0].DoctoRelacionado[0].ImpuestosDR.RetencionesDR = [];
                        self.timbre.Complemento.Pagos.Pago[0].DoctoRelacionado[0].ImpuestosDR.RetencionesDR.push({
                            "BaseDR": self.base_gravable,
                            "ImpuestoDR": "002",
                            "TipoFactorDR": "Tasa",
                            "ImporteDR": self.importe_iva_retenido,
                            "TasaOCuotaDR": self.iva_retenido
                        });
                    }
                    if (parseFloat(self.importe_isr_retenido) > 0) {
                        if (parseFloat(self.importe_iva_retenido) == 0)
                            self.timbre.Complemento.Pagos.Pago[0].DoctoRelacionado[0].ImpuestosDR.RetencionesDR = [];
                        self.timbre.Complemento.Pagos.Pago[0].DoctoRelacionado[0].ImpuestosDR.RetencionesDR.push({
                            "BaseDR": self.base_gravable,
                            "ImpuestoDR": "001",
                            "TipoFactorDR": "Tasa",
                            "ImporteDR": self.importe_isr_retenido,
                            "TasaOCuotaDR": self.isr_retenido
                        });
                    }
                    self.timbre.Complemento.Pagos.Pago[0].ImpuestosP = {};
                    if (parseFloat(self.importe_iva_retenido) > 0 || parseFloat(self.importe_isr_retenido) > 0) {
                        self.timbre.Complemento.Pagos.Pago[0].ImpuestosP.RetencionesP = [];
                        if (parseFloat(self.importe_iva_retenido) > 0) {
                            self.timbre.Complemento.Pagos.Pago[0].ImpuestosP.RetencionesP.push({
                                "ImpuestoP": "002",
                                "ImporteP": self.importe_iva_retenido,
                            }, );
                            self.timbre.Complemento.Pagos.Totales.TotalRetencionesIVA = self.importe_iva_retenido;
                        }
                        if (parseFloat(self.importe_isr_retenido) > 0) {
                            self.timbre.Complemento.Pagos.Pago[0].ImpuestosP.RetencionesP.push({
                                "ImpuestoP": "001",
                                "ImporteP": self.importe_isr_retenido,
                            }, );
                            self.timbre.Complemento.Pagos.Totales.TotalRetencionesISR = self.importe_isr_retenido;
                        }

                    }
                    if (parseFloat(self.importe_iva_traslado) > 0) {
                        self.timbre.Complemento.Pagos.Pago[0].ImpuestosP.TrasladosP = [];
                        self.timbre.Complemento.Pagos.Pago[0].ImpuestosP.TrasladosP.push({
                            "BaseP": self.base_gravable,
                            "ImpuestoP": "002",
                            "TipoFactorP": "Tasa",
                            "ImporteP": self.importe_iva_traslado,
                            "TasaOCuotaP": self.iva_traslado
                        });
                        self.timbre.Complemento.Pagos.Totales.TotalTrasladosBaseIVA16 = self.base_gravable;
                        self.timbre.Complemento.Pagos.Totales.TotalTrasladosImpuestoIVA16 = self.importe_iva_traslado;
                    }

                }

                if (parseInt(self.model.folio) > 0) {
                    self.timbre.Folio = self.model.folio;
                }
                self.timbre.Serie = self.model.serie;
                this.$root.$dialogLoader.hide();
                  this.enviarTimbrar();

            }
        },

    },
    created: function () {
        let self = this;
        this.rules = this.$rules;
        this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
        this.model.uuid_empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));

        this.URL = this.$hostname + "carta_porte/catalogos/";
        this.URL_ADM = this.$hostname + "carta_porte/administracion/";
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";

        this.cargarEmisor();
        this.cargarReceptores();
        this.cargarCatalogosSAT();

        let folio = this.$local_storage.get('UUID');
        this.impuestos = JSON.parse(this.$local_storage.get('IMPUESTOS'));
        let total = parseFloat(this.$local_storage.get('TOTAL'));
       
        let total_impuestos = parseFloat(this.impuestos.TotalImpuestosTrasladados) - parseFloat(this.impuestos.TotalImpuestosRetenidos);

        if (total_impuestos > 0)
            this.esObjeto = "02";

       
        total = parseFloat(total.toFixed(2));

        self.base_gravable = total - total_impuestos;

        if (this.impuestos != undefined) {
            if (this.impuestos.Traslados != undefined)
                this.impuestos.Traslados.forEach(function (T) {
                    if (T.Impuesto == "002") {
                        self.iva_traslado = T.TasaOCuota;
                        self.base_gravable = T.Base;
                        self.importe_iva_traslado = T.Importe;
                    }
                });
            if (this.impuestos.Retenciones != undefined)
                this.impuestos.Retenciones.forEach(function (R) {
                    if (R.Impuesto == "001") {
                        self.importe_isr_retenido = R.Importe;
                        self.isr_retenido = ((R.Importe / self.base_gravable) * 100) / 100;
                        self.isr_retenido = self.isr_retenido.toFixed(6);

                    }
                    if (R.Impuesto == "002") {
                        self.importe_iva_retenido = R.Importe;
                        self.iva_retenido = ((R.Importe / self.base_gravable) * 100) / 100;

                        if (self.iva_retenido.toFixed(4) == "0.1066")
                            self.iva_retenido = "0.106666";
                        else
                            self.iva_retenido = self.iva_retenido.toFixed(6);
                    }
                });
        }

        /*   var f_a = new Date();
          let y = f_a.getFullYear();
          let m = f_a.getMonth() + 1;
          let d = f_a.getDate();

          if (m < 10)
              m = '0' + m;

          if (d < 10)
              d = '0' + d;

          let fecha_a = y + "-" + m + "-" + d;
          this.model.FechaPago = fecha_a; */
        this.model.FechaPago = moment().format("YYYY-MM-DD");
        this.model.FechaFactura = moment().format("YYYY-MM-DD");

        if (folio != undefined && folio != '') {
            this.model.UUID = folio;
            this.model.Pago.Saldo = total;
            this.model.Pago.Pagado = total;
            this.model.Pago.Insoluto = 0.00;
        }

    },

};
</script>
